/**
 * Nuxt plugin for loading OneTrust cookie management script.
 *
 * This plugin starts loading the OneTrust script on the client-side without
 * waiting for it, and logs any error the load reports.
 *
 * @see https://www.onetrust.com/
 */
export default defineNuxtPlugin(() => {
  try {
    const { loadScript } = useOneTrustCookies()
    if (!import.meta.client) return
    // Not awaited: loadScript polls for window.OneTrust every 100ms for up to
    // 10s, and Nuxt holds the app mount until a plugin settles. Nothing rendered
    // depends on the result - the banner is opened from inside the poll callback,
    // which now runs just after mount instead of just before it. The catch is
    // required because the try block no longer sees the rejection.
    loadScript().catch(err => console.error('Error loading OneTrust', err))
  } catch (err) {
    console.error('Error loading OneTrust', err)
  }
})
